export const selectionFieldDescriptions = {
  title: 'Nome exibido na página pública do seletivo e nas inscrições dos candidatos.',
  status:
    'Rascunho mantém a publicação em preparação. Publicado exibe o seletivo habilitado, inclusive antes do início das inscrições. Arquivado retira a seleção das publicações ativas.',
  registration_starts_at:
    'Data e horário a partir dos quais as inscrições podem ser iniciadas e confirmadas. O período vale para todos os cargos deste seletivo.',
  registration_ends_at:
    'Prazo final para iniciar, editar e confirmar inscrições neste seletivo. Deve ser posterior ao início. Este prazo é diferente do período de acesso à prova.',
  public_status:
    'Define a situação apresentada ao público e usada nos filtros do portal. A opção automática acompanha o período de inscrição. Em breve, encerradas, suspenso, cancelado e finalizado impedem novas inscrições. Marcar inscrições abertas não antecipa nem estende as datas configuradas.',
  description:
    'Apresentação pública do seletivo, com as informações que o candidato verá antes de escolher um cargo.',
  terms:
    'Condições que o candidato deve aceitar ao confirmar a inscrição. Quando o texto muda, a versão das condições é atualizada.',
  requires_review:
    'Quando marcada, a inscrição confirmada aguarda análise antes do deferimento. O cadastro do candidato na OnTest continua sendo uma operação separada.',
  allow_cancellation:
    'Permite que o candidato cancele a inscrição nas situações aceitas pelo sistema, antes de sua vinculação à prova.',
};

export const positionFieldDescriptions = {
  ontest_processo_id:
    'Vínculo deste cargo com o processo correspondente na OnTest. As inscrições deferidas serão cadastradas nesse processo. O vínculo não pode ser trocado depois do cadastro.',
  title: 'Nome apresentado ao candidato no portal para identificar o cargo ou a vaga.',
  vacancies:
    'Quantidade de vagas ofertadas, exibida como informação ao candidato. Este número não limita inscrições nem faz classificação ou aprovação automática.',
  code: 'Código de identificação pública do cargo, conforme o edital ou a nomenclatura da organizadora.',
  locality: 'Cidade, região, unidade ou local de atuação associado a este cargo.',
  description: 'Informações públicas sobre as atividades e características deste cargo.',
  requirements:
    'Exigências para concorrer ao cargo, como escolaridade, formação ou experiência. O texto é informativo e não valida automaticamente o perfil do candidato.',
  published:
    'Controla a exibição do cargo no portal. O candidato só pode se inscrever se o cargo também estiver habilitado na OnTest e o seletivo estiver aberto.',
  portal_position_enabled:
    'Autoriza inscrições para este cargo na OnTest. A publicação no portal e o período de inscrição do seletivo também precisam permitir o acesso.',
  portal_exam_enabled:
    'Permite abrir a prova da OnTest a partir da inscrição no portal, dentro do período configurado e após o deferimento e cadastro do candidato na OnTest.',
  portal_exam_starts_at:
    'Primeiro momento em que o botão de acesso à prova pode ficar disponível para este cargo. Não altera o horário de realização da prova cadastrado na OnTest.',
  portal_exam_ends_at:
    'Último momento em que o portal permite abrir o link da prova deste cargo. Deve ser posterior ao início do acesso.',
};

export const formFieldDescriptions = {
  mask: 'Formata a resposta durante o preenchimento. A sugestão considera o identificador, o nome e o tipo do campo, como CEP e telefone. Você pode escolher outra máscara ou deixar o texto livre com Sem máscara.',
  file_types:
    'Permite enviar um arquivo neste campo: imagens JPG, PNG ou WebP, PDF, ou ambos os tipos. O servidor confere o formato e o tamanho. Se o campo for obrigatório, a inscrição só pode ser confirmada com um arquivo válido.',
  max_kb:
    'Tamanho máximo de cada arquivo, em quilobytes. O padrão é 5.120 KB (5 MB), com limite de até 20.480 KB (20 MB).',
  id: 'Identificador interno e único do campo. Use letras minúsculas, números e sublinhado, começando por uma letra. Alterá-lo cria outra identificação para as respostas.',
  label: 'Nome que aparece junto ao campo para orientar o candidato durante o preenchimento.',
  type: 'Formato da resposta esperada, como texto, número, data, lista, escolha única ou confirmação.',
  description: 'Orientação adicional exibida ao candidato abaixo do campo.',
  required:
    'Exige uma resposta quando o campo estiver visível. Campos de identificação obrigatórios do sistema não podem ser desativados.',
  max_length: 'Número máximo de caracteres permitido na resposta de texto.',
  min: 'Menor valor numérico aceito para este campo.',
  max: 'Maior valor numérico aceito para este campo.',
  conditions:
    'Escolha outro campo para condicionar a exibição deste. Com Sempre, ele não depende de outra resposta. Condições não podem formar dependências circulares.',
  operator:
    'Define se a resposta do outro campo deve ser igual ou diferente do valor informado para exibir este campo.',
  value:
    'Resposta do outro campo usada na comparação. Para números, informe um valor numérico; para confirmação, use true ou false.',
};
